<template>
  <div id="myNews">
    <el-tabs type="border-card" v-model="tabId">
      <el-tab-pane label="收藏的文章" name="1">
        <div class="empty" v-if="total==0">
          <img style="margin: 0 auto" :src="serve + '/image/none/none_img4.jpg'" alt="">
        </div>
        <div class="box" v-else>
          <div v-for="(item,index) of data" :key="index" class="item">
            <el-row>
              <el-col :span="5">
                <div>
                  <img :src="serve+item.cover" class="cover" />
                </div>
              </el-col>
              <el-col :span="19">
                <div @mouseenter="hover(item.new_id)" v-on:mouseleave="leave">
                  <div align="right" style="height:20px">
                    <span
                      v-if="hoverId==item.new_id"
                      class="lv3Text cancel"
                      @click="cancel(item.new_id)"
                    >取消收藏</span>
                  </div>
                  <div class="lv2Text t1">
                    <router-link :to="'/viewNews?id='+item.new_id">{{item.title}}</router-link>
                  </div>
                  <div class="lv4Text t2">{{dayjs.unix(item.create_date).format('YYYY-MM-DD')}}</div>
                  <div class="lv3Text t3">{{item.abstract}}</div>
                </div>
              </el-col>
            </el-row>
            <div class="reason"></div>
          </div>
          <div class="pager" align="center">
            <el-pagination
              background
              hide-on-single-page
              layout="prev, pager, next"
              :total="total"
              :page-size="5"
              @current-change="changePage"
            ></el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="发布文章" name="2">
        <div v-if="!end">
          <el-form label-position="right" label-width="120px" style="margin-top:30px">
            <el-form-item label="标题:">
              <el-input v-model="form.title" style="width:300px;" placeholder="请输入文章标题"></el-input>
            </el-form-item>
            <el-form-item label="作者:">
              <el-input v-model="form.writer" style="width:300px;" placeholder="多个作者用';'隔开"></el-input>
            </el-form-item>
            <el-form-item label="单位:">
              <el-input
                v-model="form.organization"
                style="width:300px;"
                placeholder="课题组 | 院系 | 研究所 | 单位"
              ></el-input>
            </el-form-item>
            <el-form-item label="摘要:">
              <el-input
                type="textarea"
                v-model="form.abstract"
                placeholder="请输入文章摘要"
                style="width:300px;"
              ></el-input>
            </el-form-item>
            <el-form-item label="基金:">
              <el-input v-model="form.fund" style="width:300px;" placeholder="请输入基金"></el-input>
            </el-form-item>
            <el-form-item label="关键词:">
              <el-input v-model="form.keyword" style="width:300px;" placeholder="多个关键词';'隔开"></el-input>
            </el-form-item>
            <el-form-item label="分类号:">
              <el-input v-model="form.class_code" style="width:300px;" placeholder="请输入分类号"></el-input>
            </el-form-item>
            <el-form-item label="上传封面:">
              <input type="file" @change="uploadCover" />
            </el-form-item>
            <el-form-item label="上传文档:">
              <input type="file" @change="uploadDoc" />
              <div class="lv3Text" style="font-size:12px">只能上传pdf格式文件，文件不能超过10M</div>
            </el-form-item>
          </el-form>
          <div style="text-align:center;margin:50px">
            <el-button type="primary" @click="submit" :loading="loading" style="width:150px">确认发布</el-button>
          </div>
        </div>
        <div v-else align="center">
          <div class="lv0Text t">
            <i class="fas fa-check-circle"></i>发布成功
            <el-button type="text" @click="reset">继续发布</el-button>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="已发布的文章" name="3">
        <div class="top">
          <el-button type="text" :class="{ 'active': status==1}" size="mini" @click="s(1)">审核通过</el-button>
          <el-button type="text" :class="{ 'active': status==0}" size="mini" @click="s(0)">审核中</el-button>
          <el-button type="text" :class="{ 'active': status==2}" size="mini" @click="s(2)">审核失败</el-button>
        </div>
        <div class="box" v-if="!myEmpty">
          <div v-for="(item,index) of myData" :key="index" class="item">
            <el-row>
              <el-col :span="5">
                <div>
                  <img :src="serve+item.cover" class="cover" />
                </div>
              </el-col>
              <el-col :span="19">
                <div class="lv2Text t1">
                  <span>{{item.title}}</span>
                </div>
                <div class="lv4Text t2">{{dayjs.unix(item.create_date).format('YYYY-MM-DD')}}</div>
                <div class="lv3Text t3">{{item.abstract}}</div>
              </el-col>
            </el-row>
            <div class="reason">
              <el-button size="mini" v-show="status==2" @click="openDialog(item.no_remark)">查看原因</el-button>
            </div>
          </div>
          <div class="pager" align="center">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="myTotal"
              hide-on-single-page
              :page-size="5"
              @current-change="changeMyPage"
            ></el-pagination>
          </div>
        </div>
        <div v-if="myEmpty">
          <div class="lv4Text empty">
            <i class="fas fa-box-open fa-2x"></i>没有内容
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="查看原因" :visible.sync="reasonDialog" width="60%">
      <span>{{reason}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reasonDialog = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //

      serve: this.$store.state.serve,

      tabId: this.$route.params.tab,
      reasonDialog: false,
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      page: 1,
      data: [],
      total: 0,
      form: {},
      coverFile: "",
      docFile: "",
      end: false,
      loading: false,
      status: 1,
      myData: [],
      myTotal: 0,
      myPage: 1,
      myEmpty: true,
      reason: "",
      hoverId: 0
    };
  },
  activated() {
    this.$store.state.user_location = "收藏的文章";
  },
  created() {
    this.initData();
  },
  methods: {
    leave() {
      this.hoverId = 0;
    },
    cancel(i) {
      this.axios
        .get(this.serve + "/collect/cancel_bioflinnews", {
          params: {
            mobile: this.mobile,
            token: this.token,
            id: i
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.$message("已取消收藏");
            this.load();
          }
        });
    },
    hover(i) {
      this.hoverId = i;
    },
    openDialog(v) {
      this.reason = v;
      this.reasonDialog = true;
    },
    s(v) {
      this.status = v;
      this.myPage = 1;
      this.loadMy();
    },
    reset() {
      this.end = false;
      this.form = {};
      this.coverFile = "";
      this.docFile = "";
    },
    submit() {
      this.loading = true;
      let form = new FormData();
      form.append("mobile", this.mobile);
      form.append("token", this.token);
      form.append("title", this.form.title);
      form.append("writer", this.form.writer);
      form.append("organization", this.form.organization);
      form.append("fund", this.form.fund);
      form.append("class_code", this.form.class_code);
      form.append("keyword", this.form.keyword);
      form.append("abstract", this.form.abstract);
      form.append("file", this.docFile);
      form.append("cover", this.coverFile);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      this.axios
        .post(
          this.serve + "/collect/create_bioflinnews",
          form,
          config
        )
        .then(res => {
          if (res.data.status == "success") {
            this.loading = false;
            this.end = true;
          }else if(res.data.status == 'error'){
            this.loading = false;
            this.$message.error(res.data.msg)
          }
        });
    },
    uploadCover(e) {
      this.coverFile = e.target.files[0];
    },
    uploadDoc(e) {
      this.docFile = e.target.files[0];
    },
    view(id) {
      this.$router.push("/viewIdle?id=" + id);
    },
    changePage(v) {
      this.page = v;
      this.load();
    },
    changeMyPage(v) {
      this.myPage = v;
      this.loadMy();
    },
    load() {
      this.data = [];
      this.axios
        .get(this.serve + "/collect/collect_bioflinnews_list", {
          params: {
            mobile: this.mobile,
            token: this.token,
            page: this.page
          }
        })
        .then(res => {
          this.data = res.data.results;
          this.total = res.data.total;
        });
    },
    loadMy() {
      this.axios
        .get(this.serve + "/collect/my_bioflinnews_list", {
          params: {
            mobile: this.mobile,
            token: this.token,
            status: this.status,
            page: this.myPage
          }
        })
        .then(res => {
          if (res.data.msg == "搜索结果为空") {
            this.myEmpty = true;
          } else {
            this.myEmpty = false;
            this.myData = res.data.data.results;
            this.myTotal = res.data.data.total;
          }
        });
    },
    initData() {
      this.axios
        .get(this.serve + "/collect/collect_bioflinnews_list", {
          params: {
            mobile: this.mobile,
            token: this.token,
            page: 1
          }
        })
        .then(res => {
          this.data = res.data.results;
          this.total = res.data.total;
        });
      this.axios
        .get(this.serve + "/collect/my_bioflinnews_list", {
          params: {
            mobile: this.mobile,
            token: this.token,
            status: 1,
            page: 1
          }
        })
        .then(res => {
          if (res.data.msg == "搜索结果为空") {
            this.myEmpty = true;
          } else {
            this.myEmpty = false;
            this.myData = res.data.data.results;
            this.myTotal = res.data.data.total;
          }
        });
    }
  }
};
</script>
<style lang="scss">
#myNews {
  .el-tabs__content {
    min-height: 600px;
  }

  .cancel {
    cursor: pointer;
    font-size: 12px;
  }
  .cancel:hover {
    text-decoration: underline;
  }
  .cover {
    width: 150px;
    height: 120px;
  }
  .reason {
    text-align: right;
    height: 28px;
    .el-button {
      position: relative;
      top: -20px;
    }
  }
  .fa-box-open {
    position: relative;
    top: 8px;
    margin-right: 10px;
  }
  .empty {
    font-size: 20px;
    text-align: center;
    padding: 30px 0;
  }
  .top {
    .el-button.active {
      border: 1px solid #e2211c;
    }
    .el-button {
      border: 1px solid #fff;
      width: 80px;
    }
  }
  .t {
    font-size: 30px;
    margin: 40px 0;
  }
  .box {
    background-color: #fff;
    padding: 20px 30px;
    .t1 {
      margin-bottom: 10px;
      margin-top: -10px;
    }
    .t2 {
      margin-bottom: 10px;
    }
  }
  .item {
    margin-bottom: 0;
  }
}
</style>